import {Component, Prop, Vue} from "vue-property-decorator";
import {Recipients} from "~/modules/notifications/lib/recipients";
import {PartnerClientDto} from "~/lib/models/app-settings";
import {getRecipients, RecipientUser} from "~/modules/notifications/service";
import {Column} from "~/components/grid/column";
import {Label} from "~/components/forms/label";
import {RecipientsSelectorList} from "~/modules/notifications/components/recipients-selector-list";
import {Checkbox} from "~/components/checkbox";
import {Columns} from "~/components/grid/columns";
import {AvailableRolesCollection} from "~/modules/notifications/lib/available-roles-collection";

@Component
export class RecipientsSelector extends Vue {

  @Prop({type: Object, required: true}) recipients: Recipients;
  @Prop({type: Array, required: true}) availableClients: PartnerClientDto[];

  protected availableRolesCollections: AvailableRolesCollection = new AvailableRolesCollection();

  protected users: RecipientUser[] = [];

  // If only one client, it is deduced as the currently edited client
  // And we pre-select it and hide the clients selection
  get isMultiClientMode() {
    return this.availableClients.length > 1;
  }

  async created() {
    await this.preloadSingleClient();
  }

  async preloadSingleClient() {
    if (!this.isMultiClientMode) {
      await this.toggleClient(this.availableClients[0].uuid);
      await this.updateUsersList();
    }
  }

  async toggleClient(clientUUID: string) {

    this.recipients.toggleClient(clientUUID);

    if (this.recipients.isClientSelected(clientUUID)) {
      await this.availableRolesCollections.load(clientUUID);
    } else {
      this.recipients.syncRoleSelection(clientUUID, this.availableRolesCollections)
    }

  }

  async updateUsersList() {
    this.users = this.recipients.isValid() ? await getRecipients(this.recipients) : [];
  }

  toggleRole(roleUUID: string) {
    this.recipients.toggleRole(roleUUID);
  }

  async toggleAllClients() {
    if (this.recipients.clientsUUIDs.length === 0) {
      for (let client of this.availableClients) {
        await this.toggleClient(client.uuid);
      }
    } else {
      for (let uuid of this.recipients.clientsUUIDs) {
        await this.toggleClient(uuid);
      }
    }
    await this.updateUsersList();
  }

  async toggleAllRoles() {
    if (this.recipients.rolesUUIDs.length === 0) {
      for (let role of this.availableRolesCollections.get(this.recipients)) {
        this.toggleRole(role.uuid);
      }
    } else {
      for (let uuid of this.recipients.rolesUUIDs) {
        this.toggleRole(uuid);
      }
    }
    await this.updateUsersList();
  }

  async reset() {
    this.availableRolesCollections = new AvailableRolesCollection();
    await this.preloadSingleClient();
    this.users = [];
  }


  renderClients() {
    if (this.isMultiClientMode) {
      return (
        <Column>
          <Label text="Clients"/>
          <SelectAll class="m-b-10" hasSelection={this.recipients.clientsUUIDs.length > 0} onToggle={this.toggleAllClients}/>
          <RecipientsSelectorList>
            {this.availableClients.map(client => {
              return (
                <div onClick={async () => {
                  await this.toggleClient(client.uuid)
                  await this.updateUsersList();
                }}>
                  <Checkbox value={this.recipients.isClientSelected(client.uuid)} static>
                    {client.name}
                  </Checkbox>
                </div>
              );
            })}
          </RecipientsSelectorList>
        </Column>
      );
    }
  }

  renderRoles() {

    let roles = this.availableRolesCollections.get(this.recipients);
    if (roles.length === 0) return <p>Aucun rôle</p>;

    return (
      <RecipientsSelectorList>
        {roles.map(role => {
          return (
            <div onClick={ async () => {
              await this.toggleRole(role.uuid);
              await this.updateUsersList();
            }}>
              <Checkbox value={this.recipients.isRoleSelected(role.uuid)} static>
                {role.label}
              </Checkbox>
            </div>
          );
        })}
      </RecipientsSelectorList>
    );
  }

  renderRecipients() {
    if (this.users.length === 0) return <p>Aucun utilisateur</p>;
    return (
      <RecipientsSelectorList>
        {this.users.map(user => <div>{user.email}</div>)}
      </RecipientsSelectorList>
    );
  }

  render() {
    return (
      <div>
        <h2 class="page-subtitle m-t-50">Destinataires</h2>
        <Columns>
          {this.renderClients()}
          <Column>
            <Label text="Roles"/>
            <SelectAll class="m-b-10" hasSelection={this.recipients.rolesUUIDs.length > 0} onToggle={this.toggleAllRoles} />
            {this.renderRoles()}
          </Column>
        </Columns>
        <Columns>
          <Column>
            <Label text={`Utilisateurs (${this.users.length})`}/>
            {this.renderRecipients()}
          </Column>
        </Columns>
      </div>
    );
  }

}


@Component
class SelectAll extends Vue {

  @Prop({type:Boolean, required:true}) hasSelection:boolean

  render() {
    return (
      <div onClick={() => this.$emit("toggle")}>
        <Checkbox value={this.hasSelection}  static>
          {this.hasSelection ? "Deselectionner tout" : "Selectionner tout"}
        </Checkbox>
      </div>
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-3ddae82b/recipients-selector.tsx" });